module.exports = __webpack_public_path__ + "static/media/623c7118249e082fe87a78e08506cb4b.623c7118.ttf";